import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "slot-container" }
const _hoisted_3 = { class: "actions-container" }

import { computed, useSlots } from 'vue'

import { Primitive } from '@/models/common'

import { normalizeFalsy } from '@/helpers/strings'

type SourceValue = null | string | number | boolean

interface Props {
  isEditingMode: boolean
  // TODO: investigate vue issues with props when Primitive type is used
  sourceValue: SourceValue | Array<SourceValue>
  saveDisabled?: boolean
  saveLoading?: boolean
  editable?: boolean

  formatter?: (value: Primitive | Primitive[]) => string
}

interface Emits {
  (e: 'save-click'): void
  (e: 'edit-click'): void
  (e: 'cancel-click'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditableTableColumn',
  props: {
    isEditingMode: { type: Boolean },
    sourceValue: { type: [null, String, Number, Boolean, Array] },
    saveDisabled: { type: Boolean, default: false },
    saveLoading: { type: Boolean, default: false },
    editable: { type: Boolean, default: true },
    formatter: {}
  },
  emits: ["save-click", "edit-click", "cancel-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const slots = useSlots()

const withPreviewSlot = computed(() => !!slots.preview)

const formattedValue = computed(() => {
  if (props.formatter) return props.formatter(props.sourceValue)

  return normalizeFalsy(props.sourceValue)
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isEditingMode)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : (withPreviewSlot.value)
          ? _renderSlot(_ctx.$slots, "preview", { key: 1 })
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(formattedValue.value), 1)
            ], 64))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isEditingMode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              disabled: _ctx.saveDisabled,
              loading: _ctx.saveLoading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('save-click')))
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Save ")
              ])),
              _: 1,
              __: [3]
            }, 8, ["disabled", "loading"]),
            _createVNode(_component_el_button, {
              size: "mini",
              type: "danger",
              disabled: _ctx.saveLoading,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel-click')))
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" Cancel ")
              ])),
              _: 1,
              __: [4]
            }, 8, ["disabled"])
          ], 64))
        : (_ctx.editable)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              icon: "el-icon-edit",
              size: "mini",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('edit-click')))
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" Edit ")
              ])),
              _: 1,
              __: [5]
            }))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})